import axios from 'axios'
import router from '@/router'
import localStorageManager from '../localStorageManager'
import * as azureAuthService from './../helpers/Office365/azureAuthService'

const ACCESS_TOKEN = 'access_token'
const IS_SYS_ADMIN = 'isSysAdmin'
const EXPIRED_AT = 'expiredAt'
const LOGIN_TIME = 'logintime'
const LAST_LOGIN_TIME = 'lastLogintime'
const USERNAME = 'username'
const REFRESH_TOKEN = 'refresh_token'
const RESET = 'RESET'
const SET_HAS_AUTH_TOKEN = 'SET_HAS_AUTH_TOKEN'
const IS_HATFIELD_STAFF = 'isHatfieldStaff'

const isAccessTokenExpired = () => {
  let accessTokenExpiry = localStorageManager.getItem(EXPIRED_AT)
  if (!accessTokenExpiry) return true

  let expiredTime = new Date(accessTokenExpiry)
  let currentTime = new Date()
  return currentTime > expiredTime
}

const initialState = () => ({
  isAccessTokenExpired,
  hasAccessToken: false,
  hasClaims: false,
  isAuthed: false,
  userinfo: {
    userId: null,
    username: '',
    isSysAdmin: false,
    isTenantAdmin: false,
    projects: [],
    apps: [],
    roleMapId: 0,
  },
})

export default {
  namespaced: true,
  state: initialState(),
  actions: {
    async checkAuth({
      state,
      dispatch,
    }) {
      var isHatfieldStaff = localStorageManager.getItem(IS_HATFIELD_STAFF)
      if(isHatfieldStaff == 'true') {
        if(!azureAuthService.isMsLoginValid()) {
          return false
        }
        
      }
      state.hasAccessToken = localStorageManager.getItem(ACCESS_TOKEN)
      if (!state.hasAccessToken) return false

      if (state.isAccessTokenExpired()) {
        return await dispatch('refreshToken')
      }

      if (state.hasClaims) {
        state.isAuthed = true
        return true
      } 

      return await dispatch('getClaims')

    },
    async impersonateLogIn({
      commit,
      dispatch,
      state,
    }, options) {
      console.log('Impersonate login...')
      try {
        let clientId = localStorageManager.requestAppId

        dispatch('clearImpersonateData')

        let res = await axios.post('token', 'grant_type=impersonate&username=' + options.username + '&client_id=' + clientId + '&code=' + options.code, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })        

        // console.log('Login results:', res)
        localStorageManager.setItem(LOGIN_TIME, new Date())
        localStorageManager.setItem(LAST_LOGIN_TIME, new Date())
        localStorageManager.setItem(USERNAME, options)
        localStorageManager.setItem(IS_HATFIELD_STAFF, true)

        state.userinfo.username = options.username
        commit('SET_LOGIN', res.data)
        await dispatch('getClaims')

        return {
          success: true,
          message: '',
        }
      } catch (error) {
        dispatch('logOut')

        if (error.response.status == 400) {
          return {
            success: false,
            error: error.response.data.error,
            message: error.response.data.error_description,
          }
        }

        return {
          success: false,
          error: 'unexpected error',
          message: 'Sorry, the service is currently unavailable. Please try again in a few minutes or contact EnviroData support for assistance.',
        }
      }
    },
    async logIn({
      commit,
      dispatch,
      state,
    }, options) {
      console.log('Logging in...')
      try {
        let clientId = localStorageManager.requestAppId
        let res = await axios.post('token', 'grant_type=password&username=' + options.username + '&password=' + options.password + '&client_id=' + clientId + '&code=' + options.code + '&code_type=' + options.codetype, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })

        // console.log('Login results:', res)
        localStorageManager.setItem(LOGIN_TIME, new Date())
        localStorageManager.setItem(LAST_LOGIN_TIME, new Date())
        localStorageManager.setItem(USERNAME, options)
        localStorageManager.setItem(IS_HATFIELD_STAFF, false)

        state.userinfo.username = options.username
        commit('SET_LOGIN', res.data)
        await dispatch('getClaims')

        return {
          success: true,
          message: '',
        }
      } catch (error) {
        dispatch('logOut')

        if (error.response.status == 400) {
          return {
            success: false,
            error: error.response.data.error,
            message: error.response.data.error_description,
          }
        }

        return {
          success: false,
          error: 'unexpected error',
          message: 'Sorry, the service is currently unavailable. Please try again in a few minutes or contact EnviroData support for assistance.',
        }
      }
    },
    async clearImpersonateData({
      commit,
    }) {
      let clientId = localStorageManager.getItem(REFRESH_TOKEN)
      if (clientId) {
        try {
          await axios.post('api/Account/LogOff', { RefreshTokenId: clientId })
        } catch (error) {
          // Token might be expired
          console.error(error)
        }
      } 
      commit('SET_LOGOUT')
    },
    async logOut({
      commit,
      dispatch,
    }, { redirect = false } = { redirect: false }) {
      let clientId = localStorageManager.getItem(REFRESH_TOKEN)
      if (clientId) {
        try {
          await axios.post('api/Account/LogOff', { RefreshTokenId: clientId })
        } catch (error) {
          // Token might be expired
          console.error(error)
        }
      }

      console.log('logOut action', redirect)      
      commit('SET_LOGOUT')
      azureAuthService.reset()
      dispatch('exitApplication', {}, { root: true })
      if (redirect) router.push('/login')
    },
    async refreshToken({
      commit,
      dispatch,
    }) {
      console.log('Refreshing token...')
      let clientId = localStorageManager.requestAppId

      try {
        let res = await axios.post('token', 'grant_type=refresh_token&&client_id=' + clientId + '&refresh_token=' + localStorageManager.getItem(REFRESH_TOKEN), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })

        console.log('Claims', res)

        commit('SET_LOGIN', res.data)
        return await dispatch('getClaims')
      } catch (error) {
        console.error(error)
        return false
      }
    },
    async getClaims({ commit, state }) {
      try {
        let res = await axios.get('api/Claims')
        commit('SET_CLAIMS', res.data)
        state.isAuthed = true
        return true
      } catch (error) {
        // Most likely the token needs to be renewed
        console.error(error)
        return false
      }
    },
    updateCurrentUserInfo({
      commit,
    }, options) {
      commit('SET_CURRENUSERINFO', options)
    },
    async requestCode({
      commit,
    }, options) {
      try {
        let res = await axios.post('api/AuthenticationCode', { Username: options.username, CodeType: options.codetype })
        return res.data
      } catch (error) {
        // Token might be expired
        console.error(error)
      }
    },
    async getAvailableTenants({
      commit,
    }, options) {
      try {
        var bearTokenHeader = `Bearer ${options.idToken}`
        //Make sure the Axios interpreter modify the header
        let res = await axios.get('api/Authenticated/' + options.email, {
          headers: {
            'Authorization': bearTokenHeader,
            'maxContentLength': 'Infinity',
          },
        })
        return res.data
      } catch (error) {
        // Token might be expired
        console.error(error)
      }
    },
  },
  mutations: {
    SET_LOGOUT(state) {
      state.isAuthed = false
      state.userinfo = {
        username: '',
        isSysAdmin: false,
        isTenantAdmin: false,
        projects: [],
        roleMapId: 0,
        apps: [],
      }

      localStorageManager.clear()
    },
    SET_LOGIN(state, value) {
      localStorageManager.setItem(ACCESS_TOKEN, value.access_token)
      localStorageManager.setItem(REFRESH_TOKEN, value.refresh_token)
      localStorageManager.setItem(EXPIRED_AT, value['.expires'])

      state.hasAccessToken = true
    },
    [SET_HAS_AUTH_TOKEN](state, value) {
      state.hasAccessToken = value
    },
    // Need to refactor code to use this
    // Leaving it out for now for consistency reasons
    // SET_AUTH(state, value) {
    //   state.isAuthed = value
    // },
    SET_CLAIMS(state, values) {
      let userId = values.find(v => v.Type == 'userId')
      let username = values.find(x => x.Type === 'name')
      let role = values.find(x => x.Type === 'role')
      let isSysAdmin = values.find(x => x.Type === 'can-admin').Value === 'True'
      let isTenantAdmin = values.find(x => x.Type === 'can-tenant-admin').Value === 'True'
      let apps = values.find(x => x.Type === 'apps')
      let roleMapId = values.find(x => x.Type === 'userGroupId')
      state.userinfo.userId = userId.Value
      state.userinfo.username = username.Value
      state.userinfo.projects = [role.Value]
      state.userinfo.isSysAdmin = isSysAdmin
      state.userinfo.isTenantAdmin = isTenantAdmin
      state.userinfo.apps = apps.Value.split(',')
      state.userinfo.roleMapId = parseInt(roleMapId.Value)
      state.hasClaims = true

      localStorageManager.setItem(USERNAME, username.Value)
      localStorageManager.setItem(IS_SYS_ADMIN, isSysAdmin)

    },
    SET_APPS(s, v) {
      s.userinfo.apps = v
    },
    SET_CURRENUSERINFO(state, values) {
      state.userinfo.projects = [values.NewRole]
      state.userinfo.isSysAdmin = values.IsSysAdmin
      state.userinfo.isTenantAdmin = values.IsTenantAdmin
      state.userinfo.roleMapId = parseInt(values.NewRoleId)
    },
    [RESET](state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
  },
  getters: {
    currentUser: (s) => s.userinfo,
    username: (s) => {
      return s.userinfo.username || ''
    },
    isAuthed: s => s.isAuthed,
    isSystemAdmin: (s) => {
      if (s.userinfo != null) {
        return s.userinfo.isSysAdmin
      }
      return false
    },
    isTenantAdmin: (s) => {
      if (s.userinfo != null) {
        return s.userinfo.isTenantAdmin
      }
      return false
    },
    isSomeAdmin: (state) => {
      return state.userinfo.isSystemAdmin || state.userinfo.isTenantAdmin
    },
    authorizedHeader: () => {
      return 'Bearer ' + localStorageManager.getItem(ACCESS_TOKEN)
    },
    hasContinuousData: (s) => {
      if (s.userinfo.apps) {
        return (s.userinfo.apps.indexOf('Stations') >= 0)
      } else {
        return false
      }
    },
    hasSampleData: (s) => {
      if (s.userinfo.apps) {
        return (s.userinfo.apps.indexOf('WaterQuality') >= 0)
      } else {
        return false
      }
    },
    // Replace with currentTenant below
    currentUserGroup: (s) => {
      if (s.userinfo) {
        return {
          name: s.userinfo.projects[0],
          id: s.userinfo.roleMapId,
        }
      }
      return null
    },
    currentTenant: (s) => {
      if (s.userinfo) {
        return {
          name: s.userinfo.projects[0],
          id: s.userinfo.roleMapId,
        }
      }
      return null
    },
    accessInfo: () => {
      let accessTokenExpiry = localStorageManager.getItem(EXPIRED_AT)
      return {
        token: localStorageManager.getItem(ACCESS_TOKEN),
        expiredTime: new Date(accessTokenExpiry),
      }
    },
  },
}